import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios, { AxiosRequestConfig } from 'axios';
import { getToken, getUserDetails } from '../../utilities/sessionHelper';
import { composeParamsString } from '../../utilities/CommonHelper';

interface SOWDetailsData {
    sowId: number;
    sowName: string;
    clientId: number;
    sowOwnerId: number;
    contractValue: string;
    sowStartDate: string;
    sowEndDate: string;
    currency: string;
  }

  interface OpportunityDetailsData {
    opportunityId: string;
    mainOpportunityName: string;
    opportunityName: string;
    businessType: string;
    description: string;
    geography: string;
  }


  
  interface EmployeeResponse {
    sowDetails: SOWDetailsData[] | null;
    opportunnityDetails: OpportunityDetailsData[]| null;
    opportunity_BuList: any[]| null;
    opportunity_clientEntityList: any[]| null;
    error: null | string;
    loading: boolean;
    isSOWDataUpdated:boolean;
    opportunityModal:{
      isModalOpen:boolean;
      selectedSOW:any;
      action:any;
    }
    confirmPopUpModal:{
      isModalOpen:boolean;
      confirmPopUpData:any;
    }
    workOrder:{
      selectedSOW:any;
    }
    workOrderModal:{
      isModalOpen:boolean;
      selectedWorkOrder:any;
      type:string;
    }
    poMappingModal:{
      isModalOpen:boolean;
      selectedWorkOrder:any;
    }
  }

  const initialState: EmployeeResponse = {
    sowDetails: null,
    opportunnityDetails: null,
    opportunity_BuList: null,
    opportunity_clientEntityList: null,
    error: null,
    loading: false,  
    isSOWDataUpdated:false,
    opportunityModal:{
      isModalOpen:false,
      selectedSOW:{},
      action:'',
    },
    confirmPopUpModal:{
      isModalOpen:false,
      confirmPopUpData:{},
    },
    workOrder:{
      selectedSOW:{},
    },
    workOrderModal:{
      isModalOpen:false,
      selectedWorkOrder:{},
      type:'create'
    },
    poMappingModal:{
      isModalOpen:false,
      selectedWorkOrder:{},
    }
};

export const fetchSowDetails:any = createAsyncThunk(
  'orderDashboard/fetchSowDetails',
  async (params:{
    page?: number;
    size?: number;
    sort?: string[];
    filters?: any;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      // const response = await axios.get(`workorder/api/sowdetails/getsowdetails`,axiosConfig);
      const response = await axios.post(`workorder/api/sowdetails/getsowdetailsByTagType`,params,axiosConfig);
       
      if (response.status!==200) {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);


export const fetchTaggedSowDetails:any = createAsyncThunk(
  'orderDashboard/fetchTaggedSowDetails',
  async (params:{
    page?: number;
    size?: number;
    sort?: string[];
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      // const response = await axios.get(`workorder/api/sowdetails/getsowdetails`,axiosConfig);
      const response = await axios.get(`workorder/api/sowdetails/getSowDetailsTags`,axiosConfig);
       
      if (response.status!==200) {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchBuAndClientDetails_Opportunity:any = createAsyncThunk(
  'orderDashboard/fetchBuAndClientDetails_Opportunity',
  async (_,{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`workorder/api/opportunity/getBuAndClientDetails`,axiosConfig);
       
      if (response.status!==200) {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchBuAndClientDetails_OBO:any = createAsyncThunk(
  'orderDashboard/fetchBuAndClientDetails_OBO',
  async (_,{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`workorder/api/obo/getBuAndClientDetails`,axiosConfig);
       
      if (response.status!==200) {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchMappedClientName:any = createAsyncThunk(
  'orderDashboard/fetchMappedClientName',
  async (params:{
    clientEntity:string;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`workorder/api/clients/findByClientEntity?clientEntity=${params.clientEntity}`,axiosConfig);
       if (response.data.status!=='OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchOpportunityDetails:any = createAsyncThunk(
  'orderDashboard/fetchOpportunityDetails',
  async (params:{
    client:string;
    bu:string;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      let value={
        client:params.client,
        bu:params.bu
      }
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.post(`workorder/api/opportunity/fetchOpportunity`,value,axiosConfig);
       if (response.data.status!=='OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchOpportunityDetails_usd:any = createAsyncThunk(
  'orderDashboard/fetchOpportunityDetails_usd',
  async (params:{
    record:any;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      const value={
        "Total_contract_value__c": params.record.Total_contract_value__c,
        "CurrencyIsoCode" : params.record.CurrencyIsoCode,
        "CloseDate": params.record.CloseDate,
        "Id": params.record.Id


      }
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.post(`workorder/api/opportunity/getOpportunityTCVInUsd`,{...value},axiosConfig);
       if (response.data.status!=='OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getCovertedCurrency:any = createAsyncThunk(
  'orderDashboard/getCovertedCurrency',
  async (params:{
    bookingMonth:string;
    quoteCurrency:string;
    baseCurrency:string;
    num:number;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.post(`workorder/api/currencyconverter/getCurrencyDetails`,params,axiosConfig);
       if (response.data.status!=='OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchOpportunityDetailsById:any = createAsyncThunk(
  'orderDashboard/fetchOpportunityDetailsById',
  async (params:{
    id:string;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`workorder/api/opportunity/fetchOpportunityById?opportunityId=${params.id}`,axiosConfig);
       if (response.data.status!=='OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);


export const fetchDuplicateSowDetails:any = createAsyncThunk(
  'orderDashboard/fetchDuplicateSowDetails',
  async (params:{
    sowId:string;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`workorder/api/sowdetails/findAllDuplicateClientEntity?sowId=${params.sowId}`,axiosConfig);
       if (response.data.status!=='OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const fetchSOWandClient:any = createAsyncThunk(
  'orderDashboard/fetchSOWandClient',
  async (_,{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`workorder/api/sowdetails/findAllSowIds`,axiosConfig);
       if (response.data.status!=='OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchWorkOrderList:any = createAsyncThunk(
  'orderDashboard/fetchWorkOrderList',
  async (
    params:{
      clientName: string;
      sowId: string;
      page?: number;
      size?: number;
      sort?: string[];
    },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
          //   'loggedInUser': 'ananda.rao@indegene.com'
        },
      
        withCredentials: true
      };
      let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`workorder/api/workorders/fetchWorkOrderDetails?clientEntity=${params.clientName}&sowId=${params.sowId}`,axiosConfig);
         
      if (response.status!==200) {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
        
      return rejectWithValue(error.message);
    }
  }
);

export const fetchMyWorkOrderList:any = createAsyncThunk(
  'orderDashboard/fetchMyWorkOrderList',
  async (
    // params:{
    //   clientName: string;
    //   sowId: string;
    //   page?: number;
    //   size?: number;
    //   sort?: string[];
    // }
    _
    ,{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
          //   'loggedInUser': 'ananda.rao@indegene.com'
        },
      
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`workorder/api/workorders/getWorkordersAgainstUser`,axiosConfig);
         
      if (response.status!==200) {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
        
      return rejectWithValue(error.message);
    }
  }
);

export const fetchClassCodes:any = createAsyncThunk(
  'orderDashboard/fetchClasscode',
  async (
    params:{
      buName: string;
      deptName: string;
      subDeptName?: string;
      // page?: number;
      // size?: number;
      // sort?: string[];
    },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
          //   'loggedInUser': 'ananda.rao@indegene.com'
        },
      
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call for classcodes
      const response = await axios.get(`workorder/api/businessUnits/classcodes?buName=${params.buName}&deptName=${params.deptName}&subDeptName=${params.subDeptName}`,axiosConfig);
      if (response.status!==200) {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
        
      return rejectWithValue(error.message);
    }
  }
);

export const fetchGeographyCode:any = createAsyncThunk(
  'orderDashboard/fetchGeographyCode',
  async (
    params:{
      clientEntity: string;
      // page?: number;
      // size?: number;
      // sort?: string[];
    },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
          //   'loggedInUser': 'ananda.rao@indegene.com'
        },
      
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call for classcodes
      const response = await axios.get(`workorder/api/businessUnits/geographyCode?clienEntity=${params.clientEntity}`,axiosConfig);

      if (response.status!==200) {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
        
      return rejectWithValue(error.message);
    }
  }
);

export const deleteWorkOrder:any = createAsyncThunk(
  'orderDashboard/deleteWorkOrder',
  async (
    params:{
      workOrderId: string;
      // page?: number;
      // size?: number;
      // sort?: string[];
    },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
          //   'loggedInUser': 'ananda.rao@indegene.com'
        },
      
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call for classcodes
      const response = await axios.get(`workorder/api/workorders?workOrderId=${params.workOrderId}`,axiosConfig);
      if (response.data.status !== 'OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
        
      return rejectWithValue(error.message);
    }
  }
);

export const deleteOboConfig:any = createAsyncThunk(
  'orderDashboard/deleteOboConfig',
  async (
    params:{
      clientName: string;
      // page?: number;
      // size?: number;
      // sort?: string[];
    },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
          //   'loggedInUser': 'ananda.rao@indegene.com'
        },
      
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call for classcodes
      const response = await axios.delete(`workorder/api/salesspoc/deleteSalesSpocClientMaster?client=${params.clientName}`,axiosConfig);
      if (response.data.status !== 'OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
        
      return rejectWithValue(error.message);
    }
  }
);

export const triggerParentId:any = createAsyncThunk(
  'orderDashboard/triggerParentId',
  async (
    params:{
      workOrderId: string;
      // page?: number;
      // size?: number;
      // sort?: string[];
    },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
          //   'loggedInUser': 'ananda.rao@indegene.com'
        },
      
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call for classcodes
      const response = await axios.get(`workorder/api/workorders/retryWorkOrderMysheet?workOrderId=${params.workOrderId}`,axiosConfig);
      if (response.data.status !== 'OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
        
      return rejectWithValue(error.message);
    }
  }
);

export const fetchFinanacialSpoc:any = createAsyncThunk(
  'orderDashboard/fetchFinanacialSpoc',
  async (
    params:{
      roleNameval: string;
      // page?: number;
      // size?: number;
      // sort?: string[];
    },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
          //   'loggedInUser': 'ananda.rao@indegene.com'
        },
      
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call for classcodes
      const response = await axios.get(`user/employeeDetails/getEmployeeDetailsByRole?roleName=${params.roleNameval}`,axiosConfig);
      if (response.status!==200) {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
        
      return rejectWithValue(error.message);
    }
  }
);



export const fetchSOWDetails:any = createAsyncThunk(
  'orderDashboard/fetchSOWDetails',
  async (
    params:{
      sowId: string;
    },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
          //   'loggedInUser': 'ananda.rao@indegene.com'
        },
      
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`workorder/api/sowdetails/${params.sowId}`,axiosConfig);
         
      if (response.status!==200) {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
        
      return rejectWithValue(error.message);
    }
  }
);
export const fetchClientIndegeneCurrency:any = createAsyncThunk(
  'orderDashboard/clientIndegeneEntityDetails',
  async (_,{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`workorder/api/workorders/getclientEntityAndindegeneEntityAndCurrency`,axiosConfig);
       if (response.data.status !=='OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchBuDepartmentSubDepartment:any = createAsyncThunk(
  'orderDashboard/fetchBuDepartmentSubDepartment',
  async (_,{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`workorder/api/businessUnits/allBusinessUnits`,axiosConfig);
       if (response.data.status !=='OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateOpportunity:any = createAsyncThunk(
  'orderDashboard/updateOpportunity',
  async (params:{
    opportunityName:string;
    opportunityId:string;
    sowId:string;
    client :string;
    bu:string;
    action:string;
    currency:string;
    OppContractValue:any;
    CurrencyIsoCode:any;
    closeDate:any;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      const values={
        opportunityName:params.opportunityName,
        opportunityId:params.opportunityId,
        sowId:params.sowId,
        client :params.client,
        bu:params.bu,
        action:params.action,
        currencyIsoCode:params.CurrencyIsoCode,
        sumTcv:params.OppContractValue,
        closeDate:params.closeDate
      }
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.post(`workorder/api/sowdetails/updatesowId`,values,axiosConfig);
      if (response.data.status !=='OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const addOrUpdateWorkOrder:any = createAsyncThunk(
  'orderDashboard/addOrUpdateWorkOrder',
  async (params:{
    values:any;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.post(`/workorder/api/workorders`,params.values,axiosConfig);
      if (response.data.status !== 'OK') {
        const errorData = await response.data.error
        if(errorData.includes("SOW_ID_VALIDATION")){
          let existingData = await response.data.data;
          return  rejectWithValue("SOW_ID_VALIDATION"+" splitter" +JSON.stringify(existingData));
        }
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getMultiYearDealDates:any = createAsyncThunk(
  'orderDashboard/getMultiYearDealDates',
  async (params:{
    values:any;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.post(`/workorder/api/workorders/getMultiYearDates`,params.values,axiosConfig);
      if (response.status !== 200) {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchAvailablePOsToMap:any = createAsyncThunk(
  'orderDashboard/fetchAvailablePOsToMap',
  async (params:{
    workOrderId:string;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`podetails/api/poWorkOrderMapping/getMappedPosAndUnMappedForWorkorder?workOrderId=${encodeURIComponent(params.workOrderId)}`,axiosConfig);
       if (response.data.status!=='OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updatePOMapping:any = createAsyncThunk(
  'orderDashboard/updatePOMapping',
  async (params:{
    payloads:any;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.post(`podetails/api/poWorkOrderMapping`,params.payloads,axiosConfig);
      if (response.data.status!=='OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const unMapPOcall:any = createAsyncThunk(
  'orderDashboard/unMapPOcall',
  async (params:{
    workOrderId:any;
    poNumber:any;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`/podetails/api/poWorkOrderMapping/unMapPoToWorkOrder?workOrderId=${params.workOrderId}&poNumber=${params.poNumber}`,axiosConfig);
      if (response.data.status!=='OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchChangeOrdersData:any = createAsyncThunk(
  'orderDashboard/fetchChangeOrdersData',
  async (params:{
    sowId:string;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`workorder/api/sowdetails/getSowDetailsHistory/${encodeURIComponent(params.sowId)}`,axiosConfig);
       if (response.data.status!=='OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchAuditlog:any = createAsyncThunk(
  'orderDashboard/fetchAuditlog',
  async (params:{
    id:string;
    module:string;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`workorder/api/myorderaudit?module=${params.module}&id=${params.id}`,axiosConfig);
       if (response.data.status!=='OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchSowTagValues:any = createAsyncThunk(
  'orderDashboard/fetchSowTagValues',
  async (params:{
    sowId: any;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`/workorder/api/sowdetails/getSowTagValues?sowId=${params.sowId}`,axiosConfig);
       if (response.data.status!=='OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchSowTagDetails:any = createAsyncThunk(
  'orderDashboard/fetchSowTagDetails',
  async (params:{
    sowId: any;
    tagName: any;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.post(`/workorder/api/sowdetails/getSowTagDetails`,params,axiosConfig);
       if (response.data.status!=='OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateSowIdTagging:any = createAsyncThunk(
  'orderDashboard/updateSowIdTagging',
  async (params:{
    openedSowId: any;
    tagType: any;
    sowId: any;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.post(`/workorder/api/sowdetails/sowIdTagging`,params,axiosConfig);
       if (response.data.status!=='OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchSOWRelations:any = createAsyncThunk(
  'orderDashboard/fetchSOWRelations',
  async (params:{
    sowId: any;
    duplicate :any
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`workorder/api/sowdetails/getSowRelations/${params.sowId}?duplicate=${params.duplicate}`,axiosConfig);
       if (response.data.status!=='OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);


export const deTagSOW:any = createAsyncThunk(
  'orderDashboard/deTagSOW',
  async (params:{
    sowId: any;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`workorder/api/sowdetails/delinkSowTags/${params.sowId}`,axiosConfig);
       if (response.data.status!=='OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const addOrUpdateOBOConfig:any = createAsyncThunk(
  'orderDashboard/addOrUpdateOBOConfig',
  async (params:{
    values:any;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.post(`/workorder/api/salesspoc/saveSalesSpocClientMaster`,params.values,axiosConfig);
      if (response.data.status !== 'OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchOboConfigData:any = createAsyncThunk(
  'orderDashboard/fetchOboConfigData',
  async (_,{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      const response = await axios.get(`/workorder/api/salesspoc/getAllSalesSpocDetails`,axiosConfig);
       if (response.data.status!=='OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    }
    catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getSowDetailsDownloadable:any = createAsyncThunk(
  'orderDashboard/getSowDetailsDownloadable',
  async (params:{
    payload?: any;
  },{rejectWithValue}) => {
    try {
        const axiosConfig : AxiosRequestConfig<any> = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
        },
        withCredentials: true,
        responseType: 'blob',
      };

      const response = await axios.post(`workorder/api/sowdetails/downloadSowReportFromEntity`,params.payload,axiosConfig);
      if (response.status !== 200) {
        const errorData = await response.data.error
        return  rejectWithValue("Something went wrong. Please try again later.");
      }
      const userData = await response;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);



const orderDashboardSlice:any = createSlice({
  name: 'orderDashboard',
  initialState,
  reducers: {
    fetchSowDetails_Request: (state) => {
      // state.loading = true;
      state.isSOWDataUpdated = true;
      state.error = null;
    },
    fetchSowDetails_Success: (state, action: PayloadAction<EmployeeResponse['sowDetails']>) => {
      state.sowDetails = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchSowDetails_Failure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    setOpportunityModalIsOpen: (state, action: PayloadAction<EmployeeResponse['opportunityModal']>) => {
         
      state.opportunityModal.isModalOpen = action.payload.isModalOpen;
      state.opportunityModal.selectedSOW = action.payload.selectedSOW;
      state.opportunityModal.action = action.payload.action;
    },
    setConfirmPopUpModalIsOpen: (state, action: PayloadAction<EmployeeResponse['confirmPopUpModal']>) => {
         
      state.confirmPopUpModal.isModalOpen = action.payload.isModalOpen;
      state.confirmPopUpModal.confirmPopUpData = action.payload.confirmPopUpData;
    },
    setWorkOrderSelectedSOW: (state, action: PayloadAction<EmployeeResponse['workOrder']>) => {
         
      state.workOrder.selectedSOW = action.payload;
    },
    setWorkOrderModalIsOpen: (state, action: PayloadAction<EmployeeResponse['workOrderModal']>) => {
      state.workOrderModal.isModalOpen = action.payload.isModalOpen;
      state.workOrderModal.selectedWorkOrder = action.payload.selectedWorkOrder;
      state.workOrderModal.type = action.payload.type;
    },
    setPOMappingModalIsOpen: (state, action: PayloadAction<EmployeeResponse['poMappingModal']>) => {
      state.poMappingModal.isModalOpen = action.payload.isModalOpen;
      state.poMappingModal.selectedWorkOrder = action.payload.selectedWorkOrder;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSowDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSowDetails.fulfilled, (state, action) => {
        state.sowDetails = action.payload;
        state.loading = false;
        state.error = null;
        state.isSOWDataUpdated = false;
      })
      .addCase(fetchSowDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchBuAndClientDetails_Opportunity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBuAndClientDetails_Opportunity.fulfilled, (state, action) => {
        state.opportunity_BuList = action.payload?.buList;
        state.opportunity_clientEntityList = action.payload?.clientList;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchBuAndClientDetails_Opportunity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchOpportunityDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOpportunityDetails.fulfilled, (state, action) => {
         
        state.opportunnityDetails = action.payload?.content;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchOpportunityDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateOpportunity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateOpportunity.fulfilled, (state, action) => {
         
        // state.opportunnityDetails = action.payload?.content;
        state.loading = false;
        state.error = null;
      })
      .addCase(updateOpportunity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchSOWandClient.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSOWandClient.fulfilled, (state, action) => {
         
        // state.opportunnityDetails = action.payload?.content;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchSOWandClient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchWorkOrderList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWorkOrderList.fulfilled, (state, action) => {
         
        // state.opportunnityDetails = action.payload?.content;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchWorkOrderList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addOrUpdateWorkOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addOrUpdateWorkOrder.fulfilled, (state, action) => {
         
        // state.opportunnityDetails = action.payload?.content;
        state.loading = false;
        state.error = null;
      })
      .addCase(addOrUpdateWorkOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchAvailablePOsToMap.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAvailablePOsToMap.fulfilled, (state, action) => {
         
        // state.opportunnityDetails = action.payload?.content;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchAvailablePOsToMap.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updatePOMapping.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePOMapping.fulfilled, (state, action) => {
         
        // state.opportunnityDetails = action.payload?.content;
        state.loading = false;
        state.error = null;
      })
      .addCase(updatePOMapping.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(unMapPOcall.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(unMapPOcall.fulfilled, (state, action) => {
         
        // state.opportunnityDetails = action.payload?.content;
        state.loading = false;
        state.error = null;
      })
      .addCase(unMapPOcall.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(triggerParentId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(triggerParentId.fulfilled, (state, action) => {
         
        // state.opportunnityDetails = action.payload?.content;
        state.loading = false;
        state.error = null;
      })
      .addCase(triggerParentId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(getMultiYearDealDates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMultiYearDealDates.fulfilled, (state, action) => {
         
        // state.opportunnityDetails = action.payload?.content;
        state.loading = false;
        state.error = null;
      })
      .addCase(getMultiYearDealDates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchChangeOrdersData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchChangeOrdersData.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchChangeOrdersData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchOpportunityDetailsById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOpportunityDetailsById.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchOpportunityDetailsById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchAuditlog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAuditlog.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchAuditlog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchMyWorkOrderList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMyWorkOrderList.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchMyWorkOrderList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchMappedClientName.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMappedClientName.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchMappedClientName.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchSowTagValues.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSowTagValues.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchSowTagValues.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchSowTagDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSowTagDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchSowTagDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchSOWRelations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSOWRelations.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchSOWRelations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(deTagSOW.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deTagSOW.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(deTagSOW.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchTaggedSowDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTaggedSowDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchTaggedSowDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addOrUpdateOBOConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addOrUpdateOBOConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(addOrUpdateOBOConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchOboConfigData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOboConfigData.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchOboConfigData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(deleteOboConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteOboConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(deleteOboConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchBuAndClientDetails_OBO.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBuAndClientDetails_OBO.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchBuAndClientDetails_OBO.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(getCovertedCurrency.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCovertedCurrency.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(getCovertedCurrency.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchDuplicateSowDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDuplicateSowDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchDuplicateSowDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchOpportunityDetails_usd.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOpportunityDetails_usd.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchOpportunityDetails_usd.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(getSowDetailsDownloadable.pending, (state) => {
        state.loading = true;
        state.error = null;
      } )
      .addCase(getSowDetailsDownloadable.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(getSowDetailsDownloadable.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
  }
});

export const {fetchSowDetails_Request, fetchSowDetails_Success, fetchSowDetails_Failure,setOpportunityModalIsOpen, setConfirmPopUpModalIsOpen , setWorkOrderSelectedSOW, setWorkOrderModalIsOpen, setPOMappingModalIsOpen } = orderDashboardSlice.actions;

export default orderDashboardSlice.reducer;